import type {
  FormFillSession,
  PatientFormValues,
  ResolvedFormBlock,
  ResolvedFormBlockConfig,
} from './types';
import { buildInitialValues } from './formPayload';

function readText(config: ResolvedFormBlockConfig): string {
  return (
    (typeof config.label === 'string' && config.label) ||
    (typeof config.text === 'string' && config.text) ||
    ''
  );
}

export function splitFormHeader(
  blocks: ResolvedFormBlock[],
  fallbackName: string,
): { title: string; intro?: string; body: ResolvedFormBlock[] } {
  let title = fallbackName;
  let intro: string | undefined;
  let body = blocks;
  if (body[0]?.block_type === 'heading') {
    title = readText(body[0].config) || title;
    body = body.slice(1);
  }
  if (body[0]?.block_type === 'paragraph') {
    intro = readText(body[0].config) || undefined;
    body = body.slice(1);
  }
  return { title, ...(intro ? { intro } : {}), body };
}

export function buildInitialFormValues(session: FormFillSession): PatientFormValues {
  return buildInitialValues(session);
}
